// src/components/Header.js
import React from 'react';
import '../styles/Header.css';
import heroVideo from '../assets/interpret.mp4';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="header">
      <video autoPlay muted loop playsInline className="hero-video">
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-content">
        <h2>Breaking Language Barriers</h2>
        <p>Your trusted partner for professional translation and interpreting services.</p>
        <Link to="/ServiceList" className="hero-button">Get a Quote</Link>
      </div>
    </header>
  );
}

export default Header;
